import Column from "@/Components/Grid/Column";
import Row from "@/Components/Grid/Row";
import Container from "@/Components/Grid/Container";
import FrontText from "../../FrontText";

const FrontBasicHero = ({heading}) => {
    return (
        <Container className="mt-10 hidden md:block">
            <Row>
                <Column>
                    <div className="bg-white shadow-gray-box px-4 lg:py-18 md:py-14 sm:py-10 py-8">
                        <FrontText textSize='28/34' className="font-semibold text-dark-blue-standard text-center">
                            <h1>{heading}</h1>
                        </FrontText>
                    </div>
                </Column>
            </Row>
        </Container>
    )
}

export default FrontBasicHero;